export type SidePanelTab = "profile" | "articles";

export type PanelUiState = {
    isCollapsed: boolean;
    activeTab: "profile" | "articles";
};

export const defaultPanelUiState: PanelUiState = {
    isCollapsed: window.innerWidth < 1280,
    activeTab: "profile",
};

export const panelUiStateKey = "state.key.panel";
